import peizhenImg from './../images/peizhen.jpg';
import peizhenImg1 from './../images/peizhenRectangle.jpg';
import pinkBullets from './../png/pink-bullet-points.png';
import alphasignLogo from './../projectLogos/alphasignLogo.png'
import brainhackLogo from './../projectLogos/brainhack.png';
import fishbowlLogo from './../projectLogos/fishbowlLogo.png';
import mtsLogo from './../projectLogos/mtsLogo.png';
import perfectMatchLogo from './../projectLogos/perfectMatchLogo.png';
import signPoseLogo from './../projectLogos/signPoseLogo.png'
import connectTuitionLogo from './../socialImpactLogos/connectTuitionLogo.png';
import evgLogo from './../socialImpactLogos/evgLogo.png';
import nusEnablersLogo from './../socialImpactLogos/nusEnablersLogo.png';
import aphroditeLogo from './../workLogos/aphroditeLogo.png';
import appleLogo from './../workLogos/appleLogo.png';
import jpmLogo from './../workLogos/jpmLogo.png';
import ogpLogo from './../workLogos/ogpLogo.png';
import oneEightyLogo from './../workLogos/oneEightyLogo.png';
import paLogo from './../workLogos/paLogo.png';
import solvewareLogo from './../workLogos/solvewareLogo.png'
export const personalInfoData = {
    themeColor: { primaryColor: "#ce4c92", pastelPink: "#F7A3DA" },
    firstName: "Pei Zhen",
    lastName: "Yap",
    areaOfInterest: "a Software Developer",
    alterEgos: [
        "Project Consultant",
        "Photographer",
        "Birdwatcher",
        "Part-Time Explorer",
        "Wildlife Lover",
        "Student Matchmaker",
        "K-Drama Fan"
    ],
    img: peizhenImg,
    img1: peizhenImg1,
    profilePattern: pinkBullets,
    aboutIntro: [
        "I hope to study the world from varied lenses and apply simple solutions to solve complex social problems. I enjoy tinkering with software development projects, and working with social enterprises to develop sustainable revenue streams.",
        "Outside of school, you'll find me taking long walks around the park, playing with my camera, and birdwatching :)"
    ],
    linkedIn: "https://www.linkedin.com/in/peizhen/",
    gitHub: "https://github.com/yappeizhen",
    email: "yappeizhen@u.nus.edu",
}

export const workExperienceData = [
    {
        name: "Open Government Products",
        role: `Software Engineer Intern – Health Appointment System`,
        img: ogpLogo,
        themeColor: "#2c6bf3 ",
        link: "https://book.health.gov.sg/"
    },
    {
        name: "Apple Media Products",
        role: "Software Engineer Intern – Quality of Service Operations",
        img: appleLogo,
        customLogoStyle: { height: 120 },
        themeColor: "#1f1f21",
    },
    {
        name: "J.P. Morgan",
        role: "Software Engineer Intern – Corporate and Investment Banking",
        img: jpmLogo,
        themeColor: "#04447b",
    },
    {
        name: "Aphrodite Project",
        role: "Core Team Developer · Singapore Chapter Lead",
        img: aphroditeLogo,
        themeColor: "#1f1f21",
        link: "https://aphrodite.global/"
    },
    {
        name: "The Solveware Co.",
        role: "Software Engineer Intern",
        img: solvewareLogo,
        themeColor: "#151d32"
    },
    {
        name: "180 Degrees Consulting NUS",
        role: "Deputy Project Leader · Project Analyst",
        img: oneEightyLogo,
        themeColor: "#1f1f21"
    },
    {
        name: "People's Association",
        role: "Central Singapore Community Development Council Intern – Skills Future Advice",
        img: paLogo,
        themeColor: "whitesmoke"
    },
]

export const projectData = [
    {
        name: "AlphaSign – Object detection web app for static sign language",
        role: "Creator",
        img: alphasignLogo,
        themeColor: "#e4dbff",
        link: "https://yappeizhen.github.io/AlphaSign",
        customLogoStyle: { height: 220 }
    },
    {
        name: "SignPose – LSTM web app for dynamic sign language",
        role: "Creator",
        img: signPoseLogo,
        themeColor: "#ddf3ff",
        link: "https://github.com/ngzhili/SignPose",
        customLogoStyle: { height: 220 }
    },
    {
        name: "Oxford Map the System 2021 – Global 2nd Place, Audience Choice Award, National Champion",
        role: "Systems Thinking Researcher and Analyst",
        img: mtsLogo,
        themeColor: "#002147",
        link: "https://mapthesystem.sbs.ox.ac.uk/map-the-system-2021",
    },
    {
        name: "Perfect Match – A business networking platform",
        role: "Full Stack Developer · Creator",
        img: perfectMatchLogo,
        themeColor: "#2b0e58"
    },
    {
        name: "DSTA Code_EXP – SafeTravels",
        role: "React Native Mobile App Developer",
        img: brainhackLogo,
        themeColor: "#000000",
        link: "https://expo.io/@yappeizhen/SafeTravels"
    },
    {
        name: "The Fishbowl Challenge 2020",
        role: "Challenger · Entrepreneur",
        img: fishbowlLogo,
        themeColor: "whitesmoke"
    },
]

export const socialImpactData = [
    {
        name: "NUS Enablers – Programmes Director",
        role: "Spearheaded several carnival events, panel forums, as well as Freshmen Orientation to promote the inclusion of students with special needs in the NUS community.",
        img: nusEnablersLogo,
        themeColor: "whitesmoke"
    },
    {
        name: "Project Agritourism – Leader",
        role: "Launched a new agricultural tourism model in Tra Vinh, Vietnam to stimulate upskilling and create sustainable income sources",
        img: evgLogo,
        themeColor: "whitesmoke"
    },
    {
        name: "Connect Tuition – Head of Relations",
        role: "Initiated a virtual mentorship programme for underprivileged students, providing tutoring support in light of COVID-19 disruptions",
        img: connectTuitionLogo,
        themeColor: "whitesmoke"
    },
]

export const skillsList = [
    {
        name: "React",
        color: "geekblue",
    },
    {
        name: "React Native",
        color: "purple",
    },
    {
        name: "Flask",
        color: "green",
    },
    {
        name: "NestJS",
        color: "gold",
    },
    {
        name: "Python",
        color: "blue",
    },
    {
        name: "Angular",
        color: "magenta"
    },
    {
        name: "Typescript",
        color: "cyan"
    },
    {
        name: "Javascript",
        color: "purple"
    },
    {
        name: "Java",
        color: "gold"
    },
    {
        name: "Java SpringBoot",
        color: "cyan"
    },
    {
        name: "Docker",
        color: "lime"
    },
    {
        name: "JPQL",
        color: "magenta"
    },
    {
        name: "PostgreSQL",
        color: "purple"
    },
    {
        name: "C",
        color: "geekblue"
    },
    {
        name: "R",
        color: "lime"
    },
    {
        name: "Systems Thinking",
        color: "orange"
    },
    {
        name: "Wiley Certified Big Data Analyst",
        color: "blue"
    },
]